"use client";

import React, { useCallback } from "react";
import { Button } from "@wtc/ui";
import Image from "next/image";
import { useEntityContextOptional } from "../contexts/EntityContextProvider";
import { useGlobalModalStack, MODAL_IDS } from "@wtc/ui";

/**
 * AskMeridianHeaderButton component
 * Button in the detail page header that opens the Ask Meridian modal
 * Uses the global modal stack to manage modal state
 *
 * Note: This component assumes entity context is available.
 * The parent component should handle conditional rendering.
 */
export function AskMeridianHeaderButton() {
  const entity = useEntityContextOptional();
  const { openModal } = useGlobalModalStack();

  const handleClick = useCallback(() => {
    openModal(MODAL_IDS.ai.askMeridianEntity);
  }, [openModal]);

  return (
    <Button
      onClick={handleClick}
      variant="outline"
      size="sm"
      className="gap-2"
      title={entity ? `Ask Meridian about this ${entity.entityType}` : "Ask Meridian"}
      aria-label={entity ? `Ask Meridian about this ${entity.entityType}` : "Ask Meridian"}
    >
      <Image src="/meridian.png" alt="Meridian" width={16} height={16} className="w-4 h-4" />
      <span className="hidden sm:inline">Ask Meridian</span>
    </Button>
  );
}
